import React from "react";
import { Container, useTheme, useMediaQuery } from "@mui/material";

export default function ResponsiveLayout({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container
      sx={{
        padding: isMobile ? "" : "3rem",
        textAlign: isMobile ? "center" : "left",
      }}
    >
      {children}
    </Container>
  );
}
